import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 120_000,        // Data is fresh for 2min — no refetch within this window
      gcTime: 600_000,           // Keep unused data in cache for 10 min
      refetchOnWindowFocus: false,
      retry: 1,
      refetchOnMount: true,      // Only refetch if data is stale (not 'always')
    },
  },
});
